module.exports = __webpack_public_path__ + "static/img/sec1-tit-bg@m.b7d0f6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hanssem/sec1-tit-bg@m.jpg
// module id = dqh5
// module chunks = 0